export const theme_dark = "THEME_DARK";
export const theme_light = "THEME_LIGHT";

export const error_wrong_channel_qty = "ERROR_WRONG_CHANNEL_QTY";
export const error_cmpxs_lack = "ERROR_CMPXS_LACK";

export const error_dataapi = "ERROR_DATAAPI";
export const error_dataapi_url_notset = error_dataapi + "_URL_NOTSET";
export const error_session_id_notset = error_dataapi + "_SESSION_NOTSET";
export const error_session_id_closed = error_dataapi + "_SESSION_CLOSED";
export const error_dataapi_request_error = error_dataapi + "_REQUEST_ERROR";
export const error_dataapi_answer_error = error_dataapi + "_ANSWER_ERROR";

export const error_common = "ERROR_COMMON";
export const error_common_markup = error_common + "_MARKUP";
export const error_common_user_directory = error_common + "_USER_DIRECTORY";
export const error_common_PDF = error_common + "_PDF";
export const error_common_wrongIDs = error_common + "_WRONGIDS";
export const error_common_request = error_common + "_REQUEST";
export const error_get_data = error_common + "_GET_DATA";
export const error_get_user_orginfo = error_common + "_GET_USER_ORGINFO";
